import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

export class PlanAbonadoEnvironmentDefinition {
    public rol = StorageManager.getUser().rol;
    
    public appName = environment.appName;
    
    public applicationType = environment.features.applicationType;
    
    public auxServerUrl = environment.serverUrl;
    
    public hasClients = environment.features.hasClients;
    
    public userCanSeeClientes = environment.features.userCanSeeClientes
        ? true
        : this.rol === 'admin';

    public showTareasMto = environment.features.showTareasMto;

    public serverUrl = environment.serverUrl;

    public clienteName = environment.features.clienteName;

    public canAddTareas = environment.features.canAddTareas;

    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;

    public canDuplicateTareas = environment.features.canDuplicateTareas;
}// class;